export default ({ COLORS }) => ({
  container: {
    '& .public-DraftEditor-content': {
      color: '#999',
      border: '1px solid #ececec',
      padding: '10px',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease-in-out',
      '&:focus': {
        borderColor: 'rgba(0,175,236,1)'
      }
    }
  },
  error: {
    '& .public-DraftEditor-content': {
      border: `1px solid ${COLORS.RED.NORMAL}`
    }
  }
})
